import { colors } from 'ui/theme';
import { noop } from 'utils/noop';
import { Delete, MakeCopy, AiSparkle16 } from 'ui/icons';
import { useJourneyAssistContext } from 'modules/workflows/context/JourneyAssistContext';
import { IconButton, SecondaryButton, BUTTON_VARIANTS } from 'ui/button';
import { StyledTilesetsBar, TilesetIcon, DeleteWrapper } from '../Footer.styles';

type TilesetsBarProps = {
  handleTilesetClick?: () => void;
  handleDuplicateClick?: () => void;
  handleDeleteClick?: () => void;
  isPublishedSelectionBar?: boolean;
};

const CLONE_TEST_ID = 'open-clone-node-modal';
const DELETE_TEST_ID = 'open-delete-node-modal';
export const CREATE_TILESET_TEST_ID = 'create-tileset-modal-button';
export const JOURNEY_ASSIST_TEST_ID = 'journey-assist-footer-button';

export const TilesetsBar = ({
  handleTilesetClick,
  handleDuplicateClick,
  handleDeleteClick,
  isPublishedSelectionBar,
  children,
}: React.PropsWithChildren<TilesetsBarProps>) => {
  const {
    shouldShowJourneyAssist,
    setIsOpen: setIsJourneyAssistOpen,
    isOpen: isJourneyAssistOpen,
    onHighlightDialog = noop,
    targetEdges,
  } = useJourneyAssistContext();
  return (
    <>
      <StyledTilesetsBar>
        <SecondaryButton data-test={CREATE_TILESET_TEST_ID} onClick={handleTilesetClick}>
          <TilesetIcon height={18} width={18} />
          Create tileset
        </SecondaryButton>
        {!isPublishedSelectionBar && (
          <>
            <SecondaryButton data-test={CLONE_TEST_ID} onClick={handleDuplicateClick}>
              <MakeCopy height={16} color={colors.secondaryText} />
              Duplicate
            </SecondaryButton>
            {shouldShowJourneyAssist && (
              <SecondaryButton
                data-test={JOURNEY_ASSIST_TEST_ID}
                onClick={() =>
                  isJourneyAssistOpen ? onHighlightDialog() : setIsJourneyAssistOpen(true)
                }
              >
                <AiSparkle16 />
                {targetEdges?.length ? 'Replace tiles' : 'Generate'}
              </SecondaryButton>
            )}
          </>
        )}
        {children}
      </StyledTilesetsBar>

      <DeleteWrapper>
        {!isPublishedSelectionBar && (
          <IconButton
            data-test={DELETE_TEST_ID}
            variant={BUTTON_VARIANTS.GHOST}
            onClick={handleDeleteClick}
          >
            <Delete />
          </IconButton>
        )}
      </DeleteWrapper>
    </>
  );
};
